import http from '@/utils/http'

export function getEventStatus(params){
    return http(`/event_statuses`,{params})
}
export function getEventStatusDetail(id){
    return http(`/event_statuses/${id}`)
}